import React, { Component } from "react";
import _ from "lodash";
// import store from "store";
import { ListingContext } from "../../Context";

import { GetListings, TranslateListing, GetParam } from "../../utils/consts";

import { Helmet } from "react-helmet";

import Banner from "@atlaskit/banner";
import WarningIcon from "@atlaskit/icon/glyph/warning";

import ListingHeader from "../../components/listingHeader/ListingHeader";
import ListingTitle from "./ListingTitle";
import ListingProperties from "./ListingProperties";
import ListingDescription from "./ListingDescription";
import ListingIncluded from "./ListingIncluded";
import ListingAmenities from "./ListingAmenities";
import ListingExtras from "./ListingExtras";
import ListingScore from "./ListingScore";
import ListingLocation from "./ListingLocation";
import ListingRealty from "./ListingRealty";
import ListingSizes from "./ListingSizes";
import ApplyCard from "../../components/applyCard/ApplyCard";

import "./listing.css";

export default class Listing extends Component {
  constructor() {
    super();
    this.state = {
      lid: "",
      loading: true,
      listing: {},
      listings: {}
    };
  }

  componentDidMount() {
    // const cachedListings = store.get("listings");
    // if (cachedListings) {
    //   this.setState({ listings: cachedListings });
    // }
    const lid = GetParam("lid", this.props);
    if (!!lid) {
      this.getListing(this.props.match.params.lid);
      this.setState({ lid: this.props.match.params.lid });
    } else {
      this.setState({
        loading: false,
        lid: ""
      });
    }
  }

  getListing = async lid => {
    try {
      const listings = await GetListings(lid);
      let listing = listings[lid];
      if (!listing) {
        this.props.addFlag({
          appearance: 2,
          title: "Listing Not Available"
        });
      }
      listing = await TranslateListing(listing);
      this.setState({
        // listings,
        loading: false,
        listing: listing || {}
      });
    } catch (error) {
      this.props.addFlag({
        appearance: 2,
        title: "Error - Please Try Again"
      });
      this.setState({
        loading: false,
        listing: {}
      });
    }
  };

  render() {
    const listing = this.state.listing || {};
    console.log(this.state);
    return (
      <ListingContext.Provider value={this.state}>
        <div className="listing padded-body">
          <Helmet>
            <title>{`${
              !!listing.title ? listing.title : ""
            } | For Rent Or Lease.`}</title>
            <meta name="description" content={listing.description} />
            {listing.photos && (
              <meta name="og:image" content={listing.photos[0]} />
            )}
          </Helmet>
          <Banner
            icon={<WarningIcon label="Warning icon" secondaryColor="inherit" />}
            isOpen={
              !this.state.loading &&
              (_.isEmpty(listing) ||
                !listing ||
                listing.status === "unavailable")
            }
            appearance="warning"
          >
            This listing is no longer available
          </Banner>
          <div id="listing" className="listing-data-apply-container">
            <div className="listing-data">
              {!!this.state.lid && (
                <ListingHeader lid={this.state.lid} hideTitle={false} />
              )}
              <ListingTitle />
              <ListingProperties />
              <ListingScore />
              <ListingDescription />
              <ListingIncluded />
              <ListingSizes />
              <ListingAmenities />
              <ListingExtras />
              <ListingLocation />
              <ListingRealty />
            </div>
            <div className="listing-apply-container">
              <ApplyCard addFlag={this.props.addFlag} />
            </div>
          </div>
        </div>
      </ListingContext.Provider>
    );
  }
}

// {<hr className="listing-section-break" />}



// WEBPACK FOOTER //
// ./src/pages/listing/Listing.js